require('ci5/smart_form')

;(function ($) {
  "use strict";

  $.widget("moneysupermarket.smart_form", $.chopin.smart_form, {
    options: {
      showHelpOnHover: false,
      showHelpOnFocus: false,
      alwaysRenameHelpTrigger: true,
      helpTriggerHtml: "<button class='help-trigger info-box-toggle' aria-label='Help' aria-expanded='false'><span>Need help?</span></button>",
      openHelpTriggerText: '<span>Need help?</span>',
      closedHelpTriggerText: '<span>Close help</span>'
    },

    _create: function () {
      this._super();

      this.element.find('.claim.control-group').each(function () {
        var $controlGroup = $(this);
        $controlGroup.on('validationchange', function () {
          if ($controlGroup.find(':input').filter('.error').length > 0) {
            $controlGroup.addClass('error');
            $controlGroup.find('.control-block.error').removeClass('error');
          } else {
            $controlGroup.removeClass('error');
          }
        });
      });

    },

    _trackSubmitted: function () {
      this._super();

      if (this.submitButton?.hasClass('js-show-modal') && this._validator.errorList.length == 0) {
        $('.loading-modal').addClass('loading-modal-show');
        $('body').addClass('stop-scrolling');
      };
    }
  });
}(window.jQuery));
